jQuery(document).ready(function ($){
  window.addEventListener("klaviyoForms", function(e) { 
    console.log(e);
        if (e.detail.type == 'submit') {
            console.log(e);
            let form = $(".klaviyo-form-" + e.detail.formId);
            form.addClass("klaviyo-form-submitted");
        }
    });


  function getInnerHeight( elm ){
  var computed = getComputedStyle(elm),
      padding = parseInt(computed.paddingTop) + parseInt(computed.paddingBottom);

  return elm.clientHeight - padding
}

  function arrowResize() {
    let carouselArrows = document.querySelectorAll(".snow-slider-rework-section .carousel-arrow");

  carouselArrows.forEach((arrow) => {
    console.log(arrow);
    let height = getInnerHeight(arrow.parentElement.parentElement.querySelector(".snow-slider"));
    console.log(height);
    arrow.style.height = height + "px";
  });


    let collectionArrows = document.querySelectorAll(".collection .carousel-arrow");

  collectionArrows.forEach((arrow) => {
    console.log(arrow);
    let height = getInnerHeight(arrow.parentElement.parentElement.querySelector(".card--product"));
    console.log(height);
    arrow.style.height = height + "px";
  });
  }

  //arrowResize();

  window.addEventListener("resize", function() {
    //arrowResize();
  });
  
});